import Axle from 'src/vehicle/chassis/axle';
import Group from 'src/vehicle/chassis/group';
import { parseUnit } from 'src/utils/units_format';

export default class AxlesCanvas {
  constructor(options = {}) {
    this._trailerOrHelper = options.trailerOrHelper != null ? options.trailerOrHelper : false;

    this._numberOfAxles = null;
    this._groups        = [];
    this._spacing       = [];
    this._loads         = [];
    this._vehicle       = App.vehicles.filter(vehicle => vehicle.id === options.vehicleId)[0];

    this._canvasEl = document.getElementById(`axles-config-canvas-${this.vehicle.id}`) ?
                   document.getElementById(`axles-config-canvas-${this.vehicle.id}`)
                 :
                   document.getElementById('axles-config-canvas');

    this._ctx = this.canvasEl.getContext('2d');

    document.addEventListener('axlesSpacingsChanged', event => {
      if (event.detail.vehicleId !== this.vehicle.id) { return; }
      this.reDraw();
    });

    document.addEventListener('axlesLoadsChanged', event => {
      if (event.detail.vehicleId !== this.vehicle.id) { return; }
      this.reDraw();
    });

    document.addEventListener('numberOfAxlesChanged', event => {
      if (event.detail.vehicleId !== this.vehicle.id) { return; }
      this.reDraw();
    });

    this.draw();
  }

  get trailerOrHelper() {
    return this._trailerOrHelper
  }

  get numberOfAxles() {
    return this._numberOfAxles
  }

  set numberOfAxles(value) {
    this._numberOfAxles = value
  }

  get groups() {
    return this._groups
  }

  set groups(value) {
    this._groups = value
  }

  get spacing() {
    return this._spacing
  }

  set spacing(value) {
    this._spacing = value
  }

  get loads() {
    return this._loads
  }

  set loads(value) {
    this._loads = value
  }

  get vehicle() {
    return this._vehicle
  }

  get canvasEl() {
    return this._canvasEl
  }

  get ctx() {
    return this._ctx
  }

  initAxles() {
    this.numberOfAxles = this.vehicle.data.numberOfAxles;
    this.spacing       = this.vehicle.data.spacing.map(el => (parseUnit(el) * 12) || 0);
    this.loads         = this.vehicle.data.loads && this.vehicle.data.loads.map(el => Number(el.replace(/\D+/g, '')));
  }

  draw() {
    this.initAxles();
    this.initGroups();
    this.render();

    return this.groups.forEach(group => {
      group.draw(this.ctx);

      if (this.loads) {
        this.ctx.font      = '14px Arial';
        this.ctx.fillStyle = 'black';
        this.ctx.textAlign = 'center';

        let acc = 0;
        group.axles.forEach(axle => acc += this.loads[axle.number - 1]);

        this.ctx.fillText(acc.toLocaleString() + ' lbs', group.centerX(), 80);
      }
    });
  }

  reDraw() {
    this.groups = [];

    this.initAxles();

    this.ctx.clearRect(0, 0, this.canvasEl.width, this.canvasEl.height); // reset canvas

    this.draw();
  }

  initGroups() {
    let group = new Group;
    group.axles.push(new Axle(1, false));

    if (this.numberOfAxles !== 1) {
      if (!this.trailerOrHelper) {
        this.groups.push(group);

        group = new Group;
        group.axles.push(new Axle(2, false));

        if (this.numberOfAxles === 2) { return this.groups.push(group); }
      }

      const threshold    = 96;
      const axlePosition = this.trailerOrHelper ? 2 : 3;

      for (let number = axlePosition, end = this.numberOfAxles, asc = axlePosition <= end; asc ? number <= end : number >= end; asc ? number++ : number--) {
        if ((this.spacing[number - 2] > threshold) || this.axleIsAPusher(number) || this.previousAxleIsAPusher(number)) {
          this.groups.push(group);
          group = new Group;
        }

        group.axles.push(new Axle(number, this.axleIsAPusher(number)));
      }
    }

    this.groups.push(group);
  }

  axleIsAPusher(number) {
    if (!this.loads) { return false; }

    return this.loads[number - 1] === 0;
  }

  previousAxleIsAPusher(number) {
    if (!this.loads) { return false; }

    return this.loads[number - 2] === 0;
  }

  render() {
    let x = 50;

    this.groups.forEach(function(group) {
      group.axles.forEach(function(axle) {
        axle.x = x;
        x += 50;
      });

      x += 50;
    });
  }
};
